import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "variant"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTextBreeze = styled(LayoutBox).withConfig({
  displayName: "TextBreeze__StyledTextBreeze",
  componentId: "sc-16zdv0n-0"
})(["@supports (-webkit-text-fill-color:transparent){background-clip:text;background-image:var(--layout-lib-gradient-", ");-webkit-text-fill-color:transparent;}"], ({
  variant
}) => variant);
export const TextBreeze = _ref => {
  let {
      as,
      children,
      variant = 'breeze-dark'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledTextBreeze, Object.assign({}, rest, {
    color: "breeze-brand",
    forwardedAs: as,
    variant: variant,
    children: children
  }));
};